{
  "version": 1,
  "asset_id": "dcb53ca1-db61-4144-85fb-d6707095acd1",
  "project_id": "1820e758-46fa-46b0-bd5a-016534d0d263",
  "url": "/__l5e/assets-v1/dcb53ca1-db61-4144-85fb-d6707095acd1/loc-fort-worth-1280.webp",
  "r2_key": "a/v1/1820e758-46fa-46b0-bd5a-016534d0d263/dcb53ca1-db61-4144-85fb-d6707095acd1/loc-fort-worth-1280.webp",
  "original_filename": "loc-fort-worth-1280.webp",
  "size": 87064,
  "content_type": "image/webp",
  "created_at": "2026-07-25T02:26:24Z"
}
